import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { DataLoadSegment, ListTable, Section, TableCellInfo, TableEmptyState } from 'js/components'
import { TaskNames } from 'js/constants'
import { useTaskSubscriber } from 'js/hooks'
import React, { ReactElement } from 'react'
import { RestModels } from 'tradehub-api-js'
import { SimpleMap } from 'js/utils'
import DelegationRow from './DelegationRow'

export interface OrdersProps {
  delegations: RestModels.ValidatorDelegation[]
  title: string
  validators: SimpleMap<RestModels.Validator>
}

interface Props extends OrdersProps { }

const Delegations: React.FunctionComponent<Props> = ({
  delegations,
  title,
  validators,
}: Props): ReactElement<Props> => {
  const [loading] = useTaskSubscriber(TaskNames.Account.Delegations)

  const headerCells: TableCellInfo[] = [
    {
      align: 'inherit',
      content: 'Validator',
    },
    {
      content: 'Amount',
    }
  ]

  return (
    <Section title={title}>
      <DataLoadSegment loading={loading}>
        <ListTable>
          <TableHead>
            <TableRow>
              {headerCells.map((cell: TableCellInfo) => (
                <TableCell align={cell?.align} key={cell?.content}>
                  {cell?.content}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              delegations.map((delegation, index) => (
                <DelegationRow
                  delegation={delegation}
                  validators={validators}
                  key={delegation?.validator_address + index}
                />
              ))
            }
          </TableBody>
        </ListTable>
        {!delegations?.length && (
          <TableEmptyState itemName="delegators" />
        )}
      </DataLoadSegment>
    </Section>
  )
}

export default Delegations
